import "core-js/modules/es.error.cause.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/esnext.typed-array.find-last.js";
import "core-js/modules/esnext.typed-array.find-last-index.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-74ec060a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "cms-page-title"
};
const _hoisted_4 = {
  class: "top_container"
};
const _hoisted_5 = {
  class: "table_list"
};
import { ref, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { ElMessage } from 'element-plus';
import dayjs from 'dayjs';
import { messageBox } from '@/utils/validate';
import AddSn from './addSN.vue';
import TipsDialog from './tipsDialog.vue';
import { getSnGroupDetailApi, changeGroupNameOrRemarkApi, deleteSnBatchApi } from '@/api/live';
import { useCommon } from '@/store/useCommon';
import { baseUrl } from '@/api/liveInstance';
export default /*#__PURE__*/_defineComponent({
  __name: 'editGroup',
  props: {
    modelValue: {
      default: false,
      type: Boolean
    },
    data: {
      default: () => {},
      type: Object
    },
    id: {
      default: undefined,
      type: Number
    }
  },
  emits: ['update:modelValue', 'updateList', 'cancel'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const loading = ref(false);
    const selectedChannelIdList = ref([]);
    const selectedChannel = ref([]);
    const fileList = reactive([]);
    const dialogVisible = ref(false);
    const formTableRef = ref();
    const isIptvAccount = JSON.parse(sessionStorage.getItem('isIptvAccount'));
    const targetUpload = ref();
    const uploadHeaders = ref({
      Token: useCommon().token,
      userId: useCommon().userData.id
    });
    const userType = isIptvAccount ? 1 : 0;
    let hostname = window.location.hostname;
    const actionUrl = computed(() => {
      if (/managemango/.test(hostname)) {
        //线上
        return `${baseUrl}/api/live/live/v2/api/web/iptv/sn/importSn?userType=${userType}&snGroupId=${props.id}&userId=${useCommon().userData.id}`;
      } else {
        //测试服
        return `${baseUrl}/live/v2/api/web/iptv/sn/importSn?userType=${userType}&snGroupId=${props.id}&userId=${useCommon().userData.id}`;
      }
    });

    const back = () => {
      emit('update:modelValue', false);
      emit('cancel', true);
    };

    const addSnObj = ref({
      visible: false,
      id: undefined,
      from: 1
    });
    watch(() => props.modelValue, (newVal, oldVal) => {
      if (newVal) {
        if (isIptvAccount) {
          //iptv账号，不显示品牌
          columnConfig.columnList.filter(item => item.label !== '品牌');
        }

        getSnGroupDetail(props.id, 1, 10);
      } else {
        addSnObj.value.id = undefined;
      }
    });

    const validRemark = (rule, value, callback) => {
      if (!value || value.trim() === '') return callback();
      if (value.length > 50) return callback(new Error(t('备注的长度应在1到50字符之间')));
      callback();
    };

    const validName = async (rule, value, callback) => {
      if (!value || value.trim() === '') return callback(new Error(t('请输入分组名称')));
      if (value.length > 50) return callback(new Error(t('分组名称的长度应在1到50字符之间')));
      callback();
    };

    const actionForm = reactive({
      formList: [[{
        label: '分组名称',
        prop: 'name',
        widgetType: 'input',
        required: true,
        rules: {
          validator: validName,
          trigger: 'blur'
        },
        blur: data => {
          changeGroupNameOrRemark('name');
        }
      }, {
        label: '备注',
        prop: 'remark',
        widgetType: 'input',
        required: false,
        rules: {
          validator: validRemark,
          trigger: 'blur'
        },
        blur: data => {
          changeGroupNameOrRemark('remark');
        }
      }]],
      formData: {}
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: true,
      paginationConfig: {
        page: 1,
        limit: 10,
        total: 0
      },
      isShowHeader: true,
      listName: 'SN列表',
      headerButtonsList: [{
        label: t('添加SN'),
        type: 'primary',
        func: () => {
          addSnObj.value.visible = true;
          addSnObj.value.id = props.id;
        }
      }, {
        label: t('移除'),
        type: 'primary',
        func: () => {
          if (selectedChannelIdList.value.length === 0) return ElMessage({
            type: 'error',
            message: t('请选择一个SN')
          });
          messageBox(`${t('确定移除SN')}`).then(() => {
            deleteSnBatch();
          });
        }
      }]
    });

    const sizeChange = size => {
      tableConfig.paginationConfig.limit = size;
      getSnGroupDetail(props.id, 1, size);
    };

    const currentChange = page => {
      tableConfig.paginationConfig.page = page;
      getSnGroupDetail(props.id, page, tableConfig.paginationConfig.limit);
    };

    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection'
      }, {
        label: 'SN',
        prop: 'sn',
        align: 'left',
        width: 200
      }, {
        label: 'Model',
        prop: 'modelName',
        align: 'left'
      }, {
        label: '品牌',
        prop: 'brandName',
        align: 'left'
      }, {
        label: '操作',
        prop: '',
        align: 'left',
        fixed: 'right',
        width: 350,
        widgetType: 'buttons',
        buttonsList: [{
          label: '移除',
          func: data => {
            messageBox(`${t('确定移除SN')}`).then(() => {
              deleteSnSingle(data.id);
            });
          }
        }]
      }]
    });

    const handleSelectionChange = row => {
      selectedChannelIdList.value = [];
      selectedChannel.value = [];

      if (row.length > 0) {
        row.forEach(val => {
          selectedChannelIdList.value.push(val.id);
          selectedChannel.value.push(val);
        });
      } //console.log('选择的频道',selectedChannel.value)

    }; //导入之前


    const handleBeforeUpload = val => {
      console.log('导入qian..', val);
      loading.value = true;
      dialogVisible.value = true;
    }; //导入失败


    const handleUploadFail = (response, file) => {
      console.log('导入失败', response);
      loading.value = false;
      dialogVisible.value = false;
      targetUpload.value.handleRemove(file); //清空浏览器保存的上次上传的文件

      getSnGroupDetail(props.id, tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
    }; //导入成功


    const handleUploadSuccess = (response, file) => {
      console.log('导入成功');

      if (response.code != 0 && response.code != -1) {
        ElMessage({
          type: 'error',
          message: t('Upload error, please upload again.')
        });
      } //下载错误文件


      if (response.code == '-1') {
        // 使用atob方法解码base64
        var raw = window.atob(response.data); // 创建一个存储解码后数据的数组

        var uInt8Array = new Uint8Array(raw.length); // blob只能接收二进制编码，需要讲base64转为二进制再塞进去

        for (var i = 0; i < raw.length; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        } // 这里给了一个返回值，在别的方法掉用传入base64编码就可以得到转化后的blob


        const link = document.createElement('a');
        console.log('link'); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet xlsl类型

        const blob = new Blob([uInt8Array], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob); //设置下载的Excel表名

        link.setAttribute('download', `ERROR_IMPORT_${dayjs(new Date()).format('YYYY-MM-DD')}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        ElMessage({
          type: 'error',
          message: t('Upload error, please upload again.')
        });
      }

      loading.value = false;
      dialogVisible.value = false;
      targetUpload.value.handleRemove(file); //清空浏览器保存的上次上传的文件

      getSnGroupDetail(props.id, tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
    }; // 获取sn详情


    const getSnGroupDetail = async (id, pageNo, pageSize) => {
      try {
        let userType = isIptvAccount ? 1 : 0;
        let userId = useCommon().userData.id;
        const {
          code,
          data
        } = await getSnGroupDetailApi(id, pageNo, pageSize, userType, userId);

        if (code == 0) {
          actionForm.formData = data.iptvSnGroup;
          tableConfig.data = data.iptvSnList.records;
          tableConfig.paginationConfig = {
            total: data.iptvSnList.total,
            page: data.iptvSnList.current,
            limit: data.iptvSnList.size
          };
        }
      } catch (error) {}
    };

    const onUpdateList = () => {
      getSnGroupDetail(props.id, tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
    }; // 改变分组名称/备注


    const changeGroupNameOrRemark = fileName => {
      formTableRef.value.mForm.validateField(fileName, async valid => {
        if (valid) {
          await changeGroupNameOrRemarkApi(actionForm.formData);
          getSnGroupDetail(props.id, tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit); //不管调用上面接口是否成功都刷新列表
        }
      });
    }; // 单独移除


    const deleteSnSingle = async id => {
      try {
        const {
          code,
          data
        } = await deleteSnBatchApi([id]);

        if (code == 0) {
          getSnGroupDetail(props.id, tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
        }
      } catch (error) {}
    }; // 批量移除


    const deleteSnBatch = async () => {
      try {
        const {
          code,
          data
        } = await deleteSnBatchApi(selectedChannelIdList.value);

        if (code == 0) {
          getSnGroupDetail(props.id, tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
        }
      } catch (error) {}
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_el_card = _resolveComponent("el-card");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [__props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('SN分组编辑')), 1), _createVNode(_component_el_button, {
        type: "primary",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_card, null, {
        default: _withCtx(() => [_createVNode(_component_FormTable, {
          col: ['20%', '30%', '20%', '30%'],
          "form-list": _unref(actionForm).formList,
          "form-data": _unref(actionForm).formData,
          ref_key: "formTableRef",
          ref: formTableRef
        }, null, 8, ["form-list", "form-data"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        ref: "tableRef",
        onSelectionChange: handleSelectionChange,
        onSizeChange: sizeChange,
        onCurrentChange: currentChange,
        onSortChange: _ctx.handleSortChange,
        "option-column-list": columnConfig.columnList
      }, {
        headerBtnSlot: _withCtx(() => [_createVNode(_component_el_upload, {
          ref_key: "targetUpload",
          ref: targetUpload,
          class: "upload_btn",
          action: _unref(actionUrl),
          method: "post",
          headers: uploadHeaders.value,
          limit: 1,
          "file-list": fileList,
          "on-exceed": _ctx.handleExceed,
          "on-error": handleUploadFail,
          "on-success": handleUploadSuccess,
          "before-upload": handleBeforeUpload
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "green"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('导入')), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["action", "headers", "file-list", "on-exceed"])]),
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "onSortChange", "option-column-list"])])])), [[_directive_loading, loading.value]]) : _createCommentVNode("", true), _createVNode(AddSn, {
        modelValue: addSnObj.value.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => addSnObj.value.visible = $event),
        snGroupId: addSnObj.value.id,
        from: addSnObj.value.from,
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue", "snGroupId", "from"]), _createVNode(TipsDialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event)
      }, null, 8, ["modelValue"])], 64);
    };
  }

});